import { LOCALES } from '../locales';

 const en = {
    [LOCALES.ENGLISH]: {
        //Header
        'navbar.ami': "AMI",
        'navbar.accueil': "Home",
        'navbar.commencer': "Begin",
        'navbar.strategie': "My strategies",
        'navbar.deconnection': "Log out",
        'navbar.capsule': "Clips",
        'navbar.contact': "Contact us",
        //Accueil
        'accueil.ami_into_titre': "Warning and important information about the AMI - Aide mémoire d'intervention application",
        'accueil.ami_intro_1': "This app was created to help you go through the difficulties you might encounter with your loved one or the person you are helping who suffers from a loss of cognitive autonomy. The app’s purpose is to offer you avenues depending on the source of the difficulty that may appear in daily life",
        'accueil.ami_intro_2': "It is possible that some avenues are more difficult to apply in certain complex and specific situations, among other thing, due to the presentation and combination of cognitive deficits, which vary greatly from one person to another. If the different advice do not work, that you feel it is asking too much effort to put them in place or that the difficulties encountered are negatively impacting the relationship between the care giver and the loved one, do not hesitate to seek help from an occupational therapist or another intervener that could help and accompany you in the application of the strategies on a daily basis",
        'accueil.ami_intro_3.1': "Through creating a user profile, ",
        'accueil.ami_intro_3.2': "the user of the app can consult and use the tools for personal use or on an individual basis only",
        'accueil.ami_intro_3.3': ". The user is not authorized to share his password or share the app and its content to anybody as each user of the application must individually register on the application to access its content.",
        'accueil.ami_intro_4.1': "All rights reserved",
        'accueil.ami_intro_4.2': ". Contents of the app, including the capsules, cannot be duplicated, shared in any way, shape of form, without the prior written permission from the",
        'accueil.ami_intro_4.3': " Laboratoire d'optimisation cognitive de l'Université de Sherbrooke (LOPCUS)",
        'accueil.ami_intro_4.4': " or to the extent permitted by law. All inquiries regarding reproduction should be directed to the person below:",
        
        'accueil.ami_intro_5.1': "Laboratoire d’optimisation cognitive de l’Université de Sherbrooke (LOPCUS)",
        'accueil.ami_intro_5.2': "Faculté de médecine et des sciences de la santé",
        'accueil.ami_intro_5.3': "Université de Sherbrooke",
        'accueil.ami_intro_5.4': "3001, 12e Ave N.",
        'accueil.ami_intro_5.5': "Sherbrooke (Québec) J1H 5H3",
        'accueil.ami_intro_5.6': "À l’attention de Pre Chantal Viscogliosi",
        'accueil.ami_intro_5.7': "Courriel: Chantal.Viscogliosi@usherbrooke.ca",
        
        'accueil.ami_intro_6': "The app was not created to be used without prior indications. It is suggested to follow a training before using the application.",
        'accueil.ami_intro_7': "The University of Sherbrooke and the creators of the app :",
        'accueil.ami_intro_8': "make no representation, warranty or indemnity as to the accuracy, validity or the exhaustivity of the content of the app;",
        'accueil.ami_intro_9': "assume no liability arising or which may arise from the use, application or interpretation of the app and its contents by any person.",

        'accueil.ami_texte': "Aide-Mémoire-Interactif (AMI)",
        'accueil.ami_description': "This application was designed to support you in dealing with the difficulties you may encounter with your loved one experiencing loss of cognitive autonomy. Its purpose is to provide you with possible solutions based on the source of the difficulty that may arise in the course of daily life.",
        'accueil.piste_description': "It is possible that certain suggestions may be more difficult to apply in certain complex and particular situations, due to the presentation and combination of cognitive deficits, which vary greatly from one person to another. If the suggested strategies are not effective, if you feel that they are requiring too much effort, or if the difficulties are interfering with your relationship with your loved one, do not hesitate to refer to an occupational therapist. They will be able to help you and accompany you in applying the strategies on a daily basis.",
        'accueil.collab': "Collaboration",
        'accueil.responsable_lopcus': "Head of the Cognitive Optimization Laboratory of the University of Sherbrooke (LOPCUS)",
        'accueil.societe_mask': "Alzheimer Society of Maskoutains-Vallée des Patriotes: Partner for the development of the application",
        'accueil.domus_chercheurs': "Researchers at the Domotics and Mobile Computer Science Research Laboratory of the University of Sherbrooke (DOMUS)",
        'accueil.etudiant_genie': "Computer Engineering students",
        'accueil.etudiant_ergo': "Occupational Therapy students",
        'accueil.ergo': "Occupational Therapists",
        'accueil.linguistique': "Linguistic revision",
        'accueil.graphisme': "Graphic design",
        'accueil.partenaires': "Our partners",
        'accueil.traduction': "Traductors",
        // Contact
        "contact.envoyer_commentaire": "Send us your feedback",
        "contact.nom_fmss": "Faculty of Medicine and Health Sciences at the University of Sherbrooke",
        "contact.adresse_ami": " 3001 12 Ave N, Sherbrooke, Quebec J1H 5H3",
        "contact.telephone_ami": "Phone: (819) 821-8000 ext. 72934",
        "contact.email_ami": "Chantal.Viscogliosi@USherbrooke.ca",
        "contact.votre_email": "Your e-mail adsress:",
        "contact.votre_nom": "Your name:",
        "contact.votre_commentaire": "Your comment:",
        "contact.envoyer": "Send",
        //Questionnaire
        "questionnaire.historique": "History",
        "questionnaire.questionnaire_ami": "AMI Questionnaire",
        "questionnaire.app_prealable": "The application is not designed to be used without prior guidance, so training is suggested before use.",
        "questionnaire.commencer": "Start",
        "questionnaire.choix_strategie": "Strategy choice",
        "questionnaire.nouv_strategie": "New strategy",
        "questionnaire.strategie_titre": "Strategy:",
        "questionnaire.creer_strategie": "Create a strategy:",
        "questionnaire.modifier_strategie": "Modify a strategy:",
        "questionnaire.chemin": "Did the pathway work?",
        "questionnaire.oui": "Yes",
        "questionnaire.non": "No",
        "questionnaire.resumer_strategie": 'To get a summary of the latest strategies you have tried for your daily situations, see the section "My strategies" ',
        "questionnaire.piste_action": "Courses of action to promote learning in daily life.",
        "questionnaire.ajouter_info": "Add more information",
        "questionnaire.choix_info": "Choice more information",
        "questionnaire.nouv_info": "New more information",
        "questionnaire.info_sup": "Additional information available:",
        "questionnaire.titre": "Title:",
        "questionnaire.lien_video": "Link to video:",
        "questionnaire.effacer_tout": "Erase all",
        "questionnaire.creer": "Create",
        "questionnaire.id": "User ID",
        "questionnaire.duree": "Duration (minutes)",
        "questionnaire.debut": "Start time",
        "questionnaire.fin": "End time",
        "questionnaire.supprimer": "Delete the selection",
        "questionnaire.status": "Statut:",
        "questionnaire.choix": "Question choice",
        "questionnaire.nouvelle_question": "new question",
        "questionnaire.modifier_question": "Modify the selected question:",
        "questionnaire.creer_question": "Create a question:",
        "questionnaire.supprimer_element": "Are you certain you want to delete this element ?",
        "questionnaire.dupliquer_element": "Are you certain you want to duplicate this element ?",
        "questionnaire.AjouterReponse": "Add response",
        "questionnaire.AjouterQuestion": "Add question",
        "questionnaire.AjouterStrategie": "Add strategy",
        "questionnaire.fonctionne": "Worked",
        "questionnaire.non_fonctionne": "Did not work",
        "questionnaire.recommencer": "Restart",
        "questionnaire.retour": "Back",
        "questionnaire.confirmer": "Confirm",
        "questionnaire.annuler": "Cancel",
        "questionnaire.autreTitle": "Customised answer",
        "questionnaire.autreDescription": "Enter your answer here",
        //Capsule
        "capsule.non_disponible": "Content not available",

        //Historique
        "historique.titre": "Strategy history",
        "historique.fonctionne": "Worked",
        "historique.non_fonctionne": "Did not work",
        "historique.recent": "Recents",
        "historique.favoris": "Favorites",
        "historique.voirStrategie": "See strategy",
        "historique.retourStrategie": "Go back to your strategies",
        "dialog.restart_title": "Are you sure you want to restart the questionnaire?",
        "dialog.yes": "Yes",
        "dialog.no": "No",
        "questionnaire.autrePlaceholder": "Enter your answer",
    }
}

export default en;